import { TextField } from '@components/common';
import { getUsaGeoLocationBasedOnZipCode } from '@services/util.service';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import css from './index.module.scss';

interface IQuoteZipcodeDischarge {
  incoTermsZipCode: string;
  incoTermsLocation: string;
  zipcodeWatch: string;
  enableZipcodeAndPlaceOfDischarge?: boolean;
}

const QuoteZipcodeDischarge = (props: IQuoteZipcodeDischarge) => {
  const { incoTermsZipCode, incoTermsLocation, zipcodeWatch } = props;

  const { control, setValue } = useFormContext();

  const getGeoLocation = async (zipCode: string) => {
    const response = await getUsaGeoLocationBasedOnZipCode(zipCode);
    if (response?.data) {
      const { data } = response;
      const placeName = data?.places[0]?.['place name'];
      const state = data?.places[0].state;
      const country = data?.country;
      const location = `${placeName}, ${state}`;
      setValue(incoTermsLocation, location);
    } else {
      // notify({
      //   severity: 'error',
      //   message: 'Please enter a valid US Zip Code'
      // });
    }
  };

  useEffect(() => {
    if (zipcodeWatch && zipcodeWatch.length === 5) {
      getGeoLocation(zipcodeWatch);
    }
  }, [zipcodeWatch]);

  return (
    <>
      <div className={css.rowWrapper}>
        <Controller
          name={incoTermsZipCode}
          control={control}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              label="Zip Code"
              error={fieldState.invalid}
              helperText={fieldState.error?.message}
            />
          )}
        />
        <Controller
          name={incoTermsLocation}
          control={control}
          render={({ field, fieldState }) => {
            return (
              <TextField
                {...field}
                label="Place of Discharge"
                error={fieldState.invalid}
                helperText={fieldState.error?.message}
              />
            );
          }}
        />
      </div>
    </>
  );
};

export default QuoteZipcodeDischarge;
